<template>
<svg fill="none" viewBox="0 0 14 14"><path d="M13.7.71a1 1 0 0 0-1.4 0L7.4 5.59 2.53.7A1 1 0 1 0 1.1 2.11L6 7l-4.9 4.89a1 1 0 0 0 1.42 1.41L7.4 8.41l4.89 4.89a1 1 0 0 0 1.4-1.41L8.83 7l4.89-4.89a1 1 0 0 0 0-1.4" class="dark:tw-fill-white tw-fill-black"/></svg>
</template>
